<main class="container-fluid">
    <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0 p-4">
        <h4>{{(sharedModel?.tipo === id_edicion)?'Editar':'Asignar'}} sanción</h4>
        <div class="col-12 mb-4">
            <div class="row justify-content-start" id="colorDiv">
              <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1 p-4">
                <label>Nombre y Apellidos</label>
                <p>{{ sharedModel?.datosPersona?.nombre }}</p>
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1 p-4">
                <label>Número de identificación</label>
                <p>{{ sharedModel?.datosPersona?.numero_identificacion }}</p>
              </div>
            </div>
        </div>
        <div class="col-12">
            <form [formGroup]="formAsignacion" (submit)="onSubmit()">
                <div class="row">
                    <div class="col-3 form-group">
                        <label class="small text-secondary" for="numero_resolucion">Número de resolución</label>
                        <input id="numero_resolucion" formControlName="numero_resolucion" type="text" class="form-control form-control-sm">
                    </div>
                    <div class="col-3 form-group">
                        <label class="small text-secondary" for="fecha_exp_acto_admin">Fecha de expedición de acto administrativo</label>
                        <input id="fecha_exp_acto_admin" formControlName="fecha_exp_acto_admin" type="date" class="form-control form-control-sm">
                    </div>
                    <div class="col-3 form-group">
                        <label class="small text-secondary" for="valor_uvt">Valor de la sanción expresada en UVT</label>
                        <input id="valor_uvt" formControlName="valor_uvt" type="number" class="form-control form-control-sm">
                    </div>
                    <div class="col-3 form-group">
                        <label class="small text-secondary" for="fecha_eje_acto_admin">Fecha ejecutoria del acto administrativo</label>
                        <input id="fecha_eje_acto_admin" formControlName="fecha_eje_acto_admin" type="date" class="form-control form-control-sm">
                    </div>
                    <div class="col-3 form-group" >
                        <label class="small text-secondary" for="sancion_estado_id">Estado de la sanción</label>
                        <select class="form-control form-control-sm"
                                id="sancion_estado_id"
                                formControlName="sancion_estado_id">
                        <ng-container *ngFor="let item of estados_sanciones">
                          <option [value]="item.sancion_estado_id">
                            {{ item.desc_sancion_estado }}
                          </option>
                        </ng-container>
                        </select>
                    </div>
                    <div class="col-3 form-group">
                        <label class="small text-secondary" for="texto_certificado">Texto a mostrar en el certificado</label>
                        <input id="texto_certificado" formControlName="texto_certificado" type="text" class="form-control form-control-sm">
                    </div>
                    <div class="col-3 form-group">
                        <label class="small text-secondary" for="motivo_sancion">Motivo</label>
                        <textarea name="motivo_sancion" id="motivo_sancion" cols="30" rows="5" formControlName="motivo_sancion" class="form-control form-control-sm"></textarea>
                    </div>
                    <div class="col-3 form-group">
                        <ng-container *ngIf="!file; else documento">
                            <div class="form-group border-dashed py-3 mb-4">
                              <div class="row">
                                <div class="col-12 text-center">
                                  <img
                                    width="85px"
                                    height="66px"
                                    src="assets/icons/upload.png"
                                  />
                                </div>
                                <div class="col-12 text-center">
                                  <label class="small text-secondary" for="nit"
                                    >Selecciona un archivo PDF menor de 15MB</label
                                  >
                                </div>
                                <div class="col-12 text-center">
                                  <button
                                    class="btn btn-outline-primary"
                                    (click)="adjuntarArchivo.click()"
                                  >
                                    Subir
                                  </button>
                                  <input
                                    #adjuntarArchivo
                                    type="file"
                                    [hidden]="true"
                                    formControlName="archivo"
                                    [accept]="extensiones"
                                    (change)="onFileInput($event)"
                                  />
                                </div>
                              </div>
                            </div>
                          </ng-container>
                          <ng-template #documento>
                            <div class="form-group content-archivo mt-1 py-2 mb-4">
                              <div class="row">
                                <div class="col-10 centrar-izquierda">
                                  <img
                                    width="38"
                                    height="39"
                                    class="ml-2"
                                    src="assets/icons/doc.png"
                                  />
                                  <div class="col-12 pl-1">
                                    <label class="col-12 p-0 m-0">{{ file.name }}</label>
                    
                                    <label class="small col-12 text-secondary p-0 m-0" for="nit">{{
                                      file.size < 1048576
                                        ? (file.size / 1024).toFixed(2) + " KB"
                                        : (file.size / 1048576).toFixed(2) + " MB"
                                    }}</label>
                                  </div>
                                </div>
                                <div class="col-2 centrar-boton">
                                  <button type="button" class="btn btn-link" (click)="cancel()">
                                    <img
                                      width="30"
                                      height="30"
                                      src="assets/icons/cancel_icon.png"
                                      class="pointer"
                                      alt="Eliminar"
                                    />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                    </div>
                    <div class="col-3">
                        <div class="w-100">
                            <div class="row">
                                <div class="col-1">
                                    <input type="checkbox" 
                                    formControlName="decreto_1836"
                                    (click)="resetCheckbox()"
                                    id="decreto_1836">
                                </div>
                                <div class="col">
                                    <label class="label label-primary medium" for="decreto_1836">{{decreto1836Label}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--fecha_inscripcion_desde-->
                    <div class="col-3 form-group">
                        <label class="text-secondary small">Fecha de inicio</label>
                        <div class="input-group">
                        <input class="form-control form-control-sm" formControlName="fecha_inicial"
                            placeholder="yyyy/mm/dd" ngbDatepicker #inicio="ngbDatepicker" (dateSelect)="onCheckDate($event)">
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary calendar" (click)="inicio.toggle()"
                            type="button"></button>
                        </div>
                        </div>
                    </div>
                    <!--fecha_inscripcion_hasta-->
                    <div class="col-3 form-group">
                        <label class="text-secondary small">Fecha fin</label>
                        <div class="input-group">
                        <input class="form-control form-control-sm" formControlName="fecha_final"
                            placeholder="yyyy/mm/dd" ngbDatepicker #fin="ngbDatepicker"  [minDate]="fecha_inicio" (dateSelect)="onCheckDate($event)">
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary calendar" (click)="fin.toggle()"
                            type="button"></button>
                        </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-4">
                  <div class="col-3">
                    <ng-container *ngIf="decreto_1836">
                      <div class="row">
                          <div class="col-12">
                              <div class="w-100">
                                  <div class="row">
                                      <div class="col-1">
                                          <input type="checkbox" 
                                          formControlName="incumplimiento_presentacion_servicio"
                                          id="incumplimiento_presentacion_servicio">
                                      </div>
                                      <div class="col">
                                          <label class="label label-primary medium" for="incumplimiento_presentacion_servicio">{{incumplimientoLabel}}</label>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="col-12">
                              <div class="w-100">
                                  <div class="row">
                                      <div class="col-1">
                                          <input type="checkbox" 
                                          formControlName="cierre_empresa_obligaciones"
                                          id="cierre_empresa_obligaciones">
                                      </div>
                                      <div class="col">
                                          <label class="label label-primary medium" for="cierre_empresa_obligaciones">{{cierreLabel}}</label>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      
                  </ng-container>
                  </div>
                </div>
                <div *ngIf="showRnt" >
                  <h5>Selecciona el RNT que le aplicará la sanción</h5>
                  
                    <form [formGroup]="formRnt" (submit)="getListadoRnt()">
                      <div class="row">
                          <div class="col-6 form-group">
                              <label class="small text-secondary" for="numero_rnt">Filtra la consulta por RNT:</label>
                              <input id="numero_rnt" formControlName="numero_rnt" type="text" class="form-control form-control-sm">
                          </div>
                          <div class="m-3">
                            <button type="reset" class="btn btn-outline-primary m-3"
                              (click)="clearList()">Limpiar</button>
                            <button class="btn btn-primary solicitud-btn-principal"
                              [disabled]="formRnt.invalid"
                              type="submit">Buscar</button>
                          </div>
                      </div>
                    </form>
                  <div class="row">
                    <app-tablas [page] = "paginaActual" 
                                [headers]="headersRnt" 
                                [sizeData]="dataTabla?.paging?.totalItems" 
                                class="table-responsive" 
                                (paginado)="onPaginado($event)"
                                *ngIf="dataTabla?.paging?.totalItems >= 1">
                        <tr *ngFor="let item of dataTabla.items; let i=index" class="small">
                          <td>
                            <input type="checkbox" [(ngModel)]="item.activo" [ngModelOptions]="{standalone: true}">
                          </td>
                          <td>{{item.codigo_rnt}}</td>
                          <td>{{item.nit}}</td>
                          <td>{{item.tipo_rnt}}</td>
                          <td>{{item.razon_social}}</td>
                          <td>{{item.codigo_camara}}</td>
                          <td>{{item.direccion_comercial}}</td>
                          <td>{{item.sub_categoria}}</td>
                          <td>{{item.fecha_inscripcion}}</td>
                          <td>{{item.ultimo_anio_renovado}}</td>
                          <td>{{item.estado_rnt}}</td>
                          <td>{{item.sanciones}}</td>
                        </tr>
                      </app-tablas>
                  </div>
                </div>
                <div class="row mt-4">
                    <div class="col-6">
                    </div>
                    <div class="col-6">
                        <div class="text-right">
                            <button type="reset" class="btn btn-outline-primary border-0 m-auto btn-align-vertical"
                              (click)="onExit()">Cancelar</button>
                            <button class="btn btn-primary m-auto solicitud-btn-principal btn-align-vertical"
                              [disabled]="formAsignacion.invalid || file == null || formAsignacion.pristine || sharedModel?.tipo === id_eliminar"
                              type="submit">Guardar</button>
                        </div>
                    </div>
                </div>
              </form>
        </div>
    </article>
    .
</main>